import React from 'react';
import Modal from '../../../../../components/Modal';
import { setWidgetContents } from '../../../../../lib/utils/widgetUtils';
import './WidgetPreviewModal.scss';

const WidgetPreviewModal = (props) => {
  const { isOpen, closeModal, pageType, changePageType, data } = props;
  const { widgetPreviewData } = data;
  const { widgetInfo, selectedWidgetItemList, widgetDetail, widgetSection } = widgetPreviewData;

  const widgetContent = setWidgetContents(
    widgetInfo,
    selectedWidgetItemList,
    widgetDetail,
    widgetSection,
    null,
    pageType,
    () => changePageType(1),
  );

  return (
    <Modal
      title={'위젯 미리보기'}
      wrapClassName="widget-preview-modal-wrapper"
      isOpen={isOpen}
      width={375}
      height={700}
      padding={'0px'}
      isFooter={true}
      okText={pageType === 0 ? '확인' : '홈 미리보기로 이동'}
      onOk={() => (pageType === 0 ? closeModal() : changePageType(0))}
      onClose={() => closeModal()}
    >
      {widgetInfo.isProductRecommend ? (
        <div className="content-wrap">
          <strong>{widgetInfo?.mainTitle || '위젯 타이틀을 설정해주세요'}</strong>
          {widgetInfo.subTitle && <p>{widgetInfo?.subTitle}</p>}
          <p className="product-recommend-type-content">
            자동 추천 위젯은
            <br /> 위젯 아이템 미리보기가 불가합니다.
          </p>
        </div>
      ) : (
        <>{widgetContent}</>
      )}
    </Modal>
  );
};

export default WidgetPreviewModal;
